const { createStyledBreakpoints } = require('./styled-breakpoints');

exports.createStyledBreakpoints = createStyledBreakpoints;
